import { SlugNameService } from './../../Services/slug-name.service';
import { EmbryoService } from "./../../Services/Embryo.service";
import {
    AfterViewInit,
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output,
    ViewChild,
} from "@angular/core";
import { Router } from "@angular/router";
import { HomePageService } from "../../Services/home-page.service";
import { ReactivityService } from "../../Services/reactivity.service";
import { Subscription } from "rxjs";
import { StaticPagesService } from "src/app/Services/static-pages.service";
import Swal from "sweetalert2";

@Component({
    selector: "embryo-WishList",
    templateUrl: "./WishList.component.html",
    styleUrls: ["./WishList.component.scss"],
})
export class WishListComponent implements OnInit, AfterViewInit, OnDestroy {
    @Input() lang: any;
    @Output() removeWishListData: EventEmitter<any> = new EventEmitter();
    @Output() addAllWishlistToCart: EventEmitter<any> = new EventEmitter();
    @Output() addToCart: EventEmitter<any> = new EventEmitter();
    @ViewChild("menuTrigger", { static: false }) menuTrigger: any;

    currency = this.embryoService.currency;
    subscription: Subscription;
    hiddenBadge = true;
    wishListProducts: Array<any> = [];
    isAuthUser: any;
    user: any;
    enteredMenu: boolean = false;
    cartList: Array<any>;
    isMobile: any;
    environmentVariables: any;
    headerIconsColor:any
     changeIconFill:boolean = true;
    constructor(
        private embryoService: EmbryoService,
        private router: Router,
        public HomeService: HomePageService,
        private reactivityService: ReactivityService,
        private pagesService: StaticPagesService,
				private slugNameService:SlugNameService,
    ) {
        this.cartList = [];
        this.subscription = this.reactivityService.storeObserver$.subscribe(
            (data: any) => {
                this.isAuthUser = JSON.parse(
                    <string>localStorage.getItem("auth_user_crocs")
                );
                if (data && data.currentFavProduct) {
                    this.addToFavList(data.currentFavProduct);
                } else if (data && data.currentUnFavouriteProduct) {
                    this.openConfirmationPopup(
                        data.currentUnFavouriteProduct,
                        null
                    );
                }
            }
        );
    }

    ngOnInit() {
        this.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(
            navigator.userAgent
        );
        this.isAuthUser = JSON.parse(
            <string>localStorage.getItem("auth_user_crocs")
        );
        this.embryoService.favouritesListSub.subscribe(
            (res) => (this.wishListProducts = res)
        );
        this.getCartData();
        this.pagesService.getenvConfig().subscribe((res: any) => {
            this.environmentVariables = res;
           this.headerIconsColor =   this.environmentVariables.HEADER_ICONS_FILL_COLOR;
        });
    }

    ngAfterViewInit() {
        this.embryoService.favouritesListSub.subscribe((res) => {
            this.wishListProducts = res;
            this.wishListProducts.forEach((product: any) => {
                product.slug_name = this.getProductName(product);
            });
        });
        this.getCartData();
        setTimeout(() => {
            this.embryoService.productCartSub.subscribe((res: any) => {
                if (res) {
                    this.wishListProducts.forEach((element: any) => {
                        let indexProduct;
                        if (res.items) {
                            indexProduct = res.items.findIndex(
                                (item: any) => item.id == element.id
                            );
                        } else {
                            indexProduct = res.findIndex(
                                (item: any) => item.id == element.id
                            );
                        }
                        if (indexProduct !== -1) {
                            element.amount = res[indexProduct].amount;
                        } else {
                            element.amount = 0;
                        }
                    });
                }
            });
        }, 10);
    }

    ngOnDestroy() {
        if (this.subscription) this.subscription.unsubscribe();
    }
    getProductName(product: any) {
        // const nameRouting = product.name_en
        //     .replace(/[^\w\s]/gi, "-")
        //     .replace(/ /g, "-");
        // const parentId = product.parent_id || product.id;
        // return nameRouting + "/" + parentId;
				return this.slugNameService.getProductName(product);
    }
    addToFavList(data: any) {
        if (this.isAuthUser) {
            this.HomeService.addToFavList(data.id).subscribe((res: any) => {
                if (res.code === 200) {
                    this.checkProduct(data);
                    this.embryoService.favouritesListSub.next(
                        this.wishListProducts
                    );
                    this.addMsg();
                } else {
                    Swal.fire({
                        html: `<p style='color:white'>${res.message}</p>`,
                        width: 250,
                        position: "bottom-end",
                        background: "#bd362f",
                        timerProgressBar: true,
                        showConfirmButton: false,
                        timer: 3000,
                        backdrop: false,
                        allowOutsideClick: true,
                    });
                }
            });
        } else {
            this.checkProduct(data);
            this.embryoService.favouritesListSub.next(this.wishListProducts);
            this.addMsg();
        }
    }

    checkProduct(product: any) {
        const clonedProduct = { ...product };
        const productsIdx = this.wishListProducts.findIndex(
            (item) => item.id === clonedProduct.id
        );
        if (productsIdx == -1) {
            clonedProduct.amount = null;
            this.wishListProducts.push(clonedProduct);
        }
    }

    unFavourite(product: any, idx = null) {
        product["loading"] = true;
        const index =
            idx ||
            this.wishListProducts.findIndex((item) => item.id === product.id);
        if (this.isAuthUser) {
            this.HomeService.removeFromFavList(product.id).subscribe(
                (res: any) => {
                    product["loading"] = false;
                    if (res.code === 200) {
                        this.wishListProducts.splice(index, 1);
                        this.removeMsg();
                    } else {
                        Swal.fire({
                            html: `<p style='color:white'>${res.message}</p>`,
                            width: 250,
                            position: "bottom-end",
                            background: "#bd362f",
                            timerProgressBar: true,
                            showConfirmButton: false,
                            timer: 3000,
                            backdrop: false,
                            allowOutsideClick: true,
                        });
                    }
                    this.embryoService.favouritesListSub.next(
                        this.wishListProducts
                    );
                }
            );
        } else {
            setTimeout(() => {
                product["loading"] = false;
                this.wishListProducts.splice(index, 1);
                this.embryoService.favouritesListSub.next(
                    this.wishListProducts
                );
                this.removeMsg();
            }, 200);
        }
    }

    addMsg() {
        const toastOption = {
            title: "Favorites",
            msg: "",
        };
        if (this.lang === "en") {
            toastOption.title = "Favorites";
            toastOption.msg = "Product added to favorites successfully";
        } else {
            toastOption.title = "المفضلة";
            toastOption.msg = "تم إضافة المنتج الي المفضلة بنجاح";
        }

        Swal.fire({
            html: `<p style='color:white'>${toastOption.msg}</p>`,
            width: 250,
            position: "bottom-end",
            background: "#51A351",
            timerProgressBar: true,
            showConfirmButton: false,
            timer: 3000,
            backdrop: false,
            allowOutsideClick: true,
        });
    }

    removeMsg() {
        const toastOption = {
            title: "Favorites",
            msg: "",
        };
        if (this.lang === "en") {
            toastOption.title = "Favorites";
            toastOption.msg = "Product removed from favorites successfully";
        } else {
            toastOption.title = "المفضلة";
            toastOption.msg = "تم إزالة المنتج من المفضلة بنجاح";
        }
        Swal.fire({
            html: `<p style='color:white'>${toastOption.msg}</p>`,
            width: 250,
            position: "bottom-end",
            background: "#51A351",
            timerProgressBar: true,
            showConfirmButton: false,
            timer: 3000,
            backdrop: false,
            allowOutsideClick: true,
        });
    }

    openConfirmationPopup(product: any, index: any | null = null) {
        this.unFavourite(product, index);
    }

    public addAllToCart() {
        const in_stock = this.wishListProducts.filter(
            (item) => item.in_stock == true
        );
        if (this.wishListProducts.length == in_stock.length) {
            this.addAllWishlistToCart.emit(this.wishListProducts);
        } else {
            in_stock.forEach((element) => {
                this.addToCart.emit(element);
            });
            Swal.fire({
                html: `<p style='color:white'>${
                    this.lang === "en"
                        ? "Ops some  products is out of stock"
                        : "بعض المنتجات غير متوفرة"
                }</p>`,
                width: 250,
                position: "bottom-end",
                background: "#bd362f",
                timerProgressBar: true,
                showConfirmButton: false,
                timer: 3000,
                backdrop: false,
                allowOutsideClick: true,
            });
        }
    }

    getCartData() {
        this.embryoService.productCartSub.subscribe((res) => {
            if (Array.isArray(res)) {
                this.cartList = res;
            }
        });
    }

    checkUserGuest() {
        this.router.navigate(["/" + this.lang + "/favorites"]);
    }

    toggleMenu(event: any, open: any) {
        if (!this.isMobile) {
            if (open) {
                event.stopPropagation();
                this.enteredMenu = false;
                this.menuTrigger.openMenu();
            } else {
                setTimeout(() => {
                    if (!this.enteredMenu) {
                        this.menuTrigger.closeMenu();
                    }
                }, 150);
            }
        }
    }

    closeMatMenu() {
        this.enteredMenu = false;
        this.menuTrigger.closeMenu();
    }
}
